<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <z-page :title="title">
        <br>

        <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
          
          <template #item-content.1>
            <br><br>
            <w-flex justify-center align-center>
              <div class="w-flex smd-column" style="width:100%">
                <div class="grow" style="flex: 0 0 49%">
                  <z-select class="mt4 w-full" outline 
                    :items="premis" 
                    label="ID / Nama Premis *" 
                    v-model="form.premis_id" 
                    @input="getTernakan(form, 2)" 
                    :validators="[validators.required]"/>
                </div>
                <div class="mx2"></div>
                <div class="grow" style="flex: 0 0 49%; display:flex; align-items:flex-end;">
                  <div class="fw-normal my1 fs-1">
                    <b>Negeri : </b>{{form.lkp_negeri}}
                  </div>
                </div>
              </div>
            </w-flex>

            <w-flex justify-center align-center>
              <div class="w-flex smd-column" style="width:100%">
                <div class="grow" style="flex: 0 0 49%">
                  <z-select class="mt4 w-full" outline 
                    :items="lkp_ternakan" 
                    label="Jenis Ternakan *" 
                    v-model="form.lkp_ternakan_id" 
                    @input="getTernakan(form, 3)" 
                    :validators="[validators.required]"/>
                </div>
                <div class="mx2"></div>
                <div class="grow" style="flex: 0 0 49%; max-width: 49%;">
                  <z-select class="mt4 w-full" outline
                    :items="lkp_status_perubahan"
                    label="Jenis Pengurusan *"
                    v-model="form.lkp_status_perubahan_id"
                    :validators="[validators.required]" />
                </div>
              </div>
            </w-flex>

            <!-- <template v-if="form.lkp_status_perubahan_id && form.lkp_status_perubahan_id == 7">
              <w-flex justify-center align-left>
                <div class="w-flex" style="width:100%">
                  <div class="grow" style="flex: 0 0 49%">
                    <w-select class="mt4 w-full" outline
                      :items="kategori_pwl"
                      label="Kategori *"
                      v-model="form.kategori_pwl"
                      :validators="[validators.required]" />
                  </div>
                </div>
              </w-flex>
            </template> -->

            <template v-if="form.lkp_status_perubahan_id && form.lkp_status_perubahan_id == 46">
              <w-flex justify-center align-left>
                <div class="w-flex" style="width:100%">
                  <div class="grow" style="flex: 0 0 49%">
                    <z-select class="mt4 w-full" outline
                      :items="kategori_lupus"
                      label="Kategori *"
                      v-model="form.kategori_lupus"
                      :validators="[validators.required]" />
                  </div>
                </div>
              </w-flex>
            </template>

            <br><br>
          </template>

          
          <template #item-content.2>
            <br><br>
            <div class="w-table-wrap" style="max-height: 400px;">
              <div class="table-profil-scrol">
                <table class="w-table w-100" color="light">
                  <thead>
                    <tr>
                      <th class="w-table__header text-center" width="1%">BIL</th>
                      <th class="w-table__header text-center">NO. PENDAFTARAN</th>
                      <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                      <th class="w-table__header text-center">ID INDUK</th>
                      <th class="w-table__header text-center">BAKA</th>
                      <th class="w-table__header text-center">JANTINA</th>
                      <th class="w-table__header text-center">TARIKH LAHIR</th>
                      <th class="w-table__header text-center">UMUR (BULAN)</th>
                      <th class="w-table__header text-center">
                        <w-checkbox v-model="checkin" @change="klickPilih()" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="ternakan_list.length == 0">
                      <td class="w-table__cell text-center" colspan="9">Tiada Data.</td>
                    </tr>
                    <tr v-for="(dt, ind) in ternakan_list" :key="ind">
                      <td class="w-table__cell text-center">{{ ind+1 }}</td>
                      <td class="w-table__cell text-center">{{ dt.kode }}</td>
                      <td class="w-table__cell text-center" style="text-transform: uppercase;">
                        {{ dt.id_ternakan }} | {{ dt.nama_ternakan }}
                      </td>
                      <td class="w-table__cell text-center">{{ dt.id_bapa }}</td>
                      <td class="w-table__cell text-center">{{ dt.lkp_baka }}</td>
                      <td class="w-table__cell text-center">{{ dt.jantina }}</td>
                      <td class="w-table__cell text-center">{{ $zutil.dateformat(dt.tarikh_lahir || '') }}</td>
                      <td class="w-table__cell text-center">{{ $zutil.umurbulan(dt.tarikh_lahir) }}</td>
                      <td class="w-table__cell text-center">
                        <template v-if="dt.baka == null">
                          <w-checkbox v-model="dt.pilih" @input="klickPi(dt) "></w-checkbox>
                        </template>
                        <template v-else>
                          <template v-if="dt.sudah_pilih == 1">
                            <w-checkbox v-model="dt.pilih" @input="klickPi(dt) "></w-checkbox>
                          </template>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br><br>
          </template>

          
          <!-- <template #item-content.3> -->
            <template v-if="tabs.some(t => t.title === 'DAFTAR MATI')" #item-content.3>
            <br><br>
              <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                  <table class="w-table" color="light">
                    <thead>
                      <tr>
                        <th class="w-table__header text-center" width="1%">BIL</th>
                        <th class="w-table__header text-center">NO. PENDAFTARAN</th>
                        <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                        <th class="w-table__header text-center">ID INDUK</th>
                        <th class="w-table__header text-center">BAKA</th>
                        <th class="w-table__header text-center">JANTINA</th>
                        <th class="w-table__header text-center">TARIKH LAHIR</th>
                        <th class="w-table__header text-center">UMUR (BULAN)</th>
                        <th class="w-table__header text-center">STATUS</th>
                        <th class="w-table__header text-center">TINDAKAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="form.ternakan_list.length == 0">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                        </tr>
                      </template>
                      <template v-for="(dt, ind) in form.ternakan_list">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center">{{ind+1}}</td>
                          <td class="w-table__cell text-center">{{dt.id_ternakan}}</td>
                          <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.ternakan_nama}}</td>
                          <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                          <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                          <td class="w-table__cell text-center">{{dt.jantina}}</td>
                          <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir ? dt.tarikh_lahir : '' )}}</td>
                          <td class="w-table__cell text-center">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                          <td class="w-table__cell text-center">
                            <template v-if="dt.status == 1">
                               Telah Dikemaskini
                            </template>
                            <template v-else>
                              Belum Dikemaskini
                            </template>
                          </td>
                          <td class="w-table__cell text-center">
                            <div class="flex justify-center gap-2">
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="warning" 
                                    dark 
                                    tile 
                                    @click="Mati(dt)">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-pencil</w-icon> 
                                  </w-button>
                                </template>
                                EDIT
                              </w-tooltip>
                              &nbsp; 
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="error-dark1" 
                                    dark 
                                    tile 
                                    @click="destroyTernakan(dt.id)" 
                                    v-if="form.lkp_status_id == 19">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-trash</w-icon> 
                                  </w-button>
                                </template>
                                PADAM
                              </w-tooltip>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
         </template>

            <!-- <template #item-content.5> -->
            <template v-if="tabs.some(t => t.title === 'PINDAH MILIK')" #item-content.3>
              <w-flex justify-start align-start style="gap:24px; width:100%;">
                 <!-- Kiri: Pilih Negeri & Premis -->
                 <div class="w-flex-col grow" style="flex:1; max-width:50%;">
                   <!-- Pilih Negeri -->
                   <z-select
                     class="mt4 w-full"
                     outline
                     :items="lkp_negeri"
                     item-text="text"
                     item-value="id"
                     label="Negeri *"
                     v-model="form.lkp_negeri_id"
                     @input="getPremisByNegeri(form.lkp_negeri_id)"
                     :validators="[validators.required]"
                   />
                   <w-input
                     class="mt4 w-full"
                     outline
                     label="Nama *"
                     v-model="form.nama"
                     :validators="[validators.required]"
                   />
                 </div>
                 
                 <div class="w-flex-col grow" style="flex:1; max-width:50%;">
                  <w-input
                     class="mt4 w-full"
                     outline
                     label="No. Telepon *"
                     v-model="form.no_tel"
                     type="tel"
                     :validators="[validators.required]"
                     />
                   <w-textarea
                     class="mt4 w-full"
                     outline
                     label="Alamat *"
                     v-model="form.alamat"
                     :validators="[validators.required]"
                     rows="3"
                   />
                 </div>
               </w-flex>



              <br>

              <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                  <table class="w-table" color="light">
                    <thead>
                      <tr>
                        <th class="w-table__header text-center" width="1%">BIL</th>
                        <th class="w-table__header text-center">NO</th>
                        <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                        <th class="w-table__header text-center">ID INDUK</th>
                        <th class="w-table__header text-center">BAKA</th>
                        <th class="w-table__header text-center">JANTINA</th>
                        <th class="w-table__header text-center">TARIKH LAHIR</th>
                        <th class="w-table__header text-center">UMUR (BULAN)</th>
                        <th class="w-table__header text-center">TINDAKAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="form.ternakan_list.length == 0">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center" colspan="9">Tiada Data.</td>
                        </tr>
                      </template>
                      <template v-for="(dt, ind) in form.ternakan_list">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center">{{ ind+1 }}</td>
                          <td class="w-table__cell text-center">{{ dt.id_ternakan }}</td>
                          <td class="w-table__cell text-center" style="text-transform: uppercase;">{{ dt.ternakan_nama }}</td>
                          <td class="w-table__cell text-center">{{ dt.id_bapa }}</td>
                          <td class="w-table__cell text-center">{{ dt.lkp_baka }}</td>
                          <td class="w-table__cell text-center">{{ dt.jantina }}</td>
                          <td class="w-table__cell text-center">{{ $zutil.dateformat(dt.tarikh_lahir ? dt.tarikh_lahir : '') }}</td>
                          <td class="w-table__cell text-center">{{ $zutil.umurbulan(dt.tarikh_lahir) }}</td>
                          <!-- <td class="w-table__cell text-center">
                            <template v-if="dt.status == 1">
                               Telah Dikemaskini
                            </template>
                            <template v-else>
                              Belum Dikemaskini
                            </template>
                          </td> -->
                          <td class="w-table__cell text-center">
                            <div class="flex justify-center gap-2">
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="primary" 
                                    dark 
                                    tile 
                                    @click="Milik(dt)">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-eye</w-icon> 
                                  </w-button>
                                </template>
                                PAPAR
                              </w-tooltip>
                              &nbsp; 
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="error-dark1" 
                                    dark 
                                    tile 
                                    @click="destroyTernakan(dt.id)" 
                                    v-if="form.lkp_status_id == 19">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-trash</w-icon> 
                                  </w-button>
                                </template>
                                PADAM
                              </w-tooltip>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
         </template>

            <!-- <template #item-content.4> -->
            <template v-if="tabs.some(t => t.title === 'LUPUS')" #item-content.3>
              <br><br>
              <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                  <table class="w-table" color="light">
                    <thead>
                      <tr>
                        <th class="w-table__header text-center" width="1%">BIL</th>
                        <th class="w-table__header text-center">NO PENDAFTARAN</th>
                        <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                        <th class="w-table__header text-center">ID INDUK</th>
                        <th class="w-table__header text-center">BAKA</th>
                        <th class="w-table__header text-center">JANTINA</th>
                        <th class="w-table__header text-center">TARIKH LAHIR</th>
                        <th class="w-table__header text-center">UMUR (BULAN)</th>
                        <th class="w-table__header text-center">STATUS</th>
                        <th class="w-table__header text-center">TINDAKAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="form.ternakan_list.length == 0">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                        </tr>
                      </template>
                      <template v-for="(dt, ind) in form.ternakan_list">
                        <tr class="w-table__row">
                          <td class="w-table__cell text-center">{{ind+1}}</td>
                          <td class="w-table__cell text-center">{{dt.id_ternakan}}</td>
                          <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.ternakan_nama}}</td>
                          <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                          <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                          <td class="w-table__cell text-center">{{dt.jantina}}</td>
                          <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir ? dt.tarikh_lahir : '' )}}</td>
                          <td class="w-table__cell text-center">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                          <td class="w-table__cell text-center">
                            <template v-if="dt.status == 1">
                               Telah Dikemaskini
                            </template>
                            <template v-else>
                              Belum Dikemaskini
                            </template>
                          </td>
                          <td class="w-table__cell text-center">
                            <div class="flex justify-center gap-2">
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="warning" 
                                    dark 
                                    tile 
                                    @click="Singkir(dt)">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-pencil</w-icon> 
                                  </w-button>
                                </template>
                                EDIT
                              </w-tooltip>
                              &nbsp; 
                              <w-tooltip top color="white" bg-color="black">
                                <template #activator="{ on }">
                                  <w-button 
                                    class="be fs-2" 
                                    v-on="on" 
                                    bg-color="error-dark1" 
                                    dark 
                                    tile 
                                    @click="destroyTernakan(dt.id)" 
                                    v-if="form.lkp_status_id == 19">
                                    <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-trash</w-icon> 
                                  </w-button>
                                </template>
                                PADAM
                              </w-tooltip>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
          </template>
        </w-tabs>

        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
          <template v-if="activeTab == 0">
            <w-button class="my1" type="submit" @click="getTernakan(form);">
              SETERUSNYA
            </w-button>
          </template>
          <template v-else-if="activeTab == 1 && (form.lkp_status_id == 19 || form.lkp_status_id == 0)">
            <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2)">
              <w-icon dark tile class="mr2">fal fa-save</w-icon> SETERUSNYA
            </w-button>
          </template>
          <template v-if="activeTab == 2 || activeTab == 3 || activeTab == 4 && form.lkp_status_id == 19">

                <!-- <template v-if="activeTab == 4 && form.lkp_status_id == 19">
                  <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                    <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                  </w-button>
               </template> -->
            &nbsp;
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
          </template>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup()">TUTUP</w-button>&nbsp;
        </div>
      </z-page>
    </w-form>

    
    <w-dialog
      v-model="dialogMati.show"
      :fullscreen="dialogMati.fullscreen"
      width="650"
      :persistent="dialogMati.persistent"
      :persistent-no-animation="dialogMati.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        {{ form.ternakan_list[0]?.ternakan_nama }}
      </template>
      <w-form 
        ref="form_mati" 
        v-model="form_mati.valid" 
        @validate="validateFormMati" 
        @success="success">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <template v-if="$zutil.anyRole(['2','5'])">
              <div class="w-flex items-center mt3">
                <label class="w-40 mr2"><b>Tarikh Kematian*</b></label>
                <w-input
                  class="w-60"
                  outline
                  type="date"
                  v-model="form_mati.tarikh_kematian"
                  :validators="[validators.required]"/>
              </div>
              <div class="w-flex items-center mt3">
                <label class="w-40 mr2"><b>Sebab Kematian*</b></label>
                <w-textarea 
                  class="w-60"
                  outline
                  v-model="form_mati.sebab_kematian" 
                  :validators="[validators.required]"/>
              </div>
              <template v-if="form.kategori_pwl == 1">
                <br>
                <span class="mt4 block"><b>Muat Naik Salinan Dokumen</b></span>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Laporan Postmortem dari<br/>(PVD Daerah/ DVS Negeri/ Makmal Kesihatan Veterinar)</label>
                  <w-input class="w-60" type="file" :preview="false" outline accept="image/*,application/pdf" v-model="files_postmertem" multiple />
                </div>
                  <template v-for="dt, ind  in attahecmentPostmertem">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Surat Perakuan Pampasan</label>
                  <w-input class="w-60" type="file" :preview="false" outline accept="image/*,application/pdf" v-model="files_pampasan" multiple />
                </div>
                <template v-for="dt, ind  in attahecmentPampasan">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Permit Sembelih</label>
                  <w-input class="w-60" type="file" :preview="false" outline accept="image/*,application/pdf" v-model="files_permit" multiple />
                </div>
                <template v-for="dt, ind  in attahecmentPermit">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>

                <br>
                <span class="mt4 block"><b>Muat Naik Gambar Terkini</b></span>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Gambar Sebelum</label>
                  <w-input class="w-60" type="file" :preview="false" outline accept="image/*" v-model="img_sebelum" multiple />
                </div>
                     <template v-for="dt, ind  in attahecmentImgSebelum">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Gambar Semasa</label>
                  <w-input class="w-60" type="file" :preview="false" outline accept="image/*" v-model="img_semasa" multiple />
                </div>
                     <template v-for="dt, ind  in attahecmentImgSemasa">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>

                <br>
                <span class="mt4 block"><b>Muat Naik Keputusan Darah (Sekiranya ada)</b></span>
                <div class="w-flex items-center mt3">
                  <label class="w-40 mr2">Keputusan Darah</label>
                  <w-input class="w-60" type="file" :preview="false" accept="image/*,application/pdf" v-model="files_darah" outline />
                </div>
                <template v-for="dt, ind  in attahecmentDarah">
                              <div class="fw-normal my1 fs-1">  
                                 <a :href="dt.url">{{ dt.name }}</a>
                                  <!-- <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                              </div>
                           </template>
              </template>
            </template>
          </div>
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogMati.show = false">TUTUP</w-button>
        <w-button class="ml1" :loading="dialogMati.loading" @click="$refs.form_mati.validate()">SIMPAN</w-button>
      </template>
    </w-dialog>

    
    <w-dialog
      v-model="dialogMilik.show"
      :fullscreen="dialogMilik.fullscreen"
      width="700"
      :persistent="dialogMilik.persistent"
      :persistent-no-animation="dialogMilik.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        Maklumat Ternakan
      </template>

      <w-form
        ref="form_milik"
        v-model="dialogMilik.valid"
        @validate="validateFormMilik"
        @success="success">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <div
              v-for="(dt, ind) in form.ternakan_list"
              :key="dt.id"
              class="pa3 mb3 rounded-lg border border-grey-light5">
              
              <div class="w-flex smd-column">
                
                <div class="grow pr4">
                  <div class="mb2"><b>No. Pendaftaran:</b> {{ dt.no_pendaftaran }}</div>
                  <div class="mb2"><b>ID/Nama Ternakan:</b> {{ dt.ternakan_nama }}</div>
                  <div class="mb2"><b>Jenis Ternakan:</b> {{ dt.lkp_ternakan }}</div>
                  <div class="mb2"><b>Baka:</b> {{ dt.lkp_baka }}</div>
                  <div class="mb2"><b>Jantina:</b> {{ dt.jantina }}</div>
                  <div class="mb2"><b>Tarikh lahir:</b> {{ dt.tarikh_lahir }}</div>
                </div>

                
                <div class="grow pl4 border-l border-grey-light5">
                  <div class="mb2"><b>ID Pejantan:</b> {{ dt.id_bapa }}</div>
                  <div class="mb2"><b>Baka Pejantan:</b> {{ dt.nama_bapa }}</div>
                  <div class="mb2"><b>ID Induk:</b> {{ dt.id_ibu }}</div>
                  <div class="mb2"><b>Baka Induk:</b> {{ dt.nama_ibu }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogMilik.show = false">
          TUTUP
        </w-button>

       <!--  <w-button
          class="ml1"
          :loading="dialogMilik.loading"
          @click="$refs.form_sijil.validate()">
          SIMPAN
        </w-button> -->
      </template>
    </w-dialog>

    
    <w-dialog
      v-model="dialogSingkir.show"
      :fullscreen="dialogSingkir.fullscreen"
      width="600"
      :persistent="dialogSingkir.persistent"
      :persistent-no-animation="dialogSingkir.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        {{ form.ternakan_list[0]?.ternakan_nama }}
      </template>

      <w-form 
        ref="form_singkir" 
        v-model="dialogSingkir.valid" 
        @validate="validateFormSingkir" 
        @success="success">
        <div class="w-flex wrap smd-column">
          <div class="grow">
            <template v-if="$zutil.anyRole(['2','5'])">
              <!-- Tarikh Singkir -->
              <div class="w-flex items-center mt3">
                <label class="w-40 mr2"><b>Tarikh Lupus*</b></label>
                <w-input
                  class="w-60"
                  outline
                  type="date"
                  v-model="form_singkir.tarikh_singkir"
                  :validators="[validators.required]"/>
              </div>

              <!-- Sebab Singkir -->
              <div class="w-flex items-center mt3">
                <label class="w-40 mr2"><b>Sebab Lupus*</b></label>
                <z-select
                    class="w-60"
                    outline
                    :items="status_singkir"
                    v-model="form_singkir.sebab_singkir"
                    :validators="[validators.required]"
                  />
              </div>
            </template>
          </div>
        </div>
      </w-form>

      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSingkir.show = false">TUTUP</w-button>
        <w-button class="ml1" :loading="dialogSingkir.loading" @click="$refs.form_singkir.validate()">SIMPAN</w-button>
      </template>
    </w-dialog>

    <w-dialog
          v-model="dialog.show"
          :fullscreen="dialog.fullscreen"
          width="800"
          :persistent="dialog.persistent"
          :persistent-no-animation="dialog.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  CARIAN PREMIS
        </template>
        <w-flex justify-center align-center>
                <div class="xs8">
                       <w-input label="Nama Premis (Carian minimun 2 aksara)" v-model="carian_juru.q"> </w-input>
                </div>
                <div class="xs4">
                      <w-button class="ml1" @click="getPremisByNegeri(form)">Cari</w-button>
                </div>
            </w-flex>
            <br>
            <br>
               <div class="w-table-wrap" style="max-height: 400px;">
                 <div class="table-profil-scrol">
                   <table class="w-table ">
                       <thead>
                         <tr>
                             <th class="w-table__header w-table__header--sortable text-left">No</th>
                             <th class="w-table__header w-table__header--sortable text-left"> Nama Premis</th>
                             <th class="w-table__header w-table__header--sortable text-left"> Pilih</th>
                         </tr>
                       </thead>
                       <tbody>
                         
                             <tr v-for="dt, index in premis">
                                 <td class="w-table__cell text-left">
                                     {{(index+1)}}
                                 </td>
                                 <td class="w-table__cell ">
                                     {{dt.label}}
                                 </td>
                                 <td class="w-table__cell text-center">
                                     <w-radio class="mr2" v-model="form.premis_id" :return-value="dt.value" @click="dialog.show = false"></w-radio>
                                 </td>
                             </tr>
                       </tbody>
                     </table>
                 </div>
               </div>
         
        <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
         </template>
        
    </w-dialog>


  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'baka.perubahan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan perubahan', route: 'baka/perubahan' },
        { label: 'Permohonan', route: 'baka//perubahan/permohonan' },
      ],
      // tabs: [],
      // tabs: [
      //   { title: 'PERMOHONAN', content: '' },
      //   { title: 'TERNAKAN', content: ''},
      //   { title: 'MATI/LUPUS', content: ''}, 
      //   { title: 'SINGKIR', content: ''}, 
      //   { title: 'PINDAH MILIK', content: ''}, 
      // ],
      activeTab: 0,
      tabs: [
        { title: 'PERMOHONAN', content: '' },
        { title: 'TERNAKAN', content: '' },
      ],
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      negeri : '',
      title : 'Pengurusan  Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      carian_juru : {q: ''},
      ternakan_list:[],
      baka_dokumen_list:[],
      premis : [],
      lkp_ternakan : [],
      jenis_baka : [],
      lkp_kaedah_pembiakan : [],
      lkpbakaDokumen : [],
      lkp_status_perubahan : [],
      status_singkir: [],
      kategori_pwl:[
        {value: 1, label: "PWL"},
        {value: 2, label: "Bukan PWL"},
      ],
      kategori_lupus:[
        {value: 1, label: "Sembelih"},
        {value: 2, label: "Hilang"},
        {value: 3, label: "Singkir PWL"},
      ],
      slides:[],
      tarikh_today:'',
      // activeTab : 0,
      checkin:false,
      loading:false,
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      },
      dialogMati: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialogMilik: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialogSingkir: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      files_dokumen:[],
      files:[],
      img:[],
      attahecment:[],
      attahecmentImgSemasa:[],
      attahecmentImgSebelum:[],
      attahecmentDarah:[],
      attahecmentPostmertem:[],
      attahecmentPampasan:[],
      attahecmentPermit:[],
    }
  },
  methods: {
   Mati(dt){
         this.form_mati = {
            id : dt.id,
            tarikh_kematian : dt.tarikh_kematian,
            sebab_kematian : dt.sebab_kematian,

         }
         this.files_postmertem = '',
         this.files_pampasan = '',
         this.files_permit = '',
         this.img_sebelum = '',
         this.img_semasa = '',
         this.files_darah = '',

      this.getAttahecmentImgSemasa(dt.id)
      this.getAttahecmentImgSebelum(dt.id)
      this.getAttahecmentDarah(dt.id)
      this.getAttahecmentPostmertem(dt.id)
      this.getAttahecmentPampasan(dt.id)
      this.getAttahecmentPermit(dt.id)

        this.dialogMati.show = true;
        this.form.saveButton = "Simpan"
    },

   Milik(dt){
         this.form_ = {
             id : dt.id,
         }
         this.files = ''

         
         this.getPremisByNegeri(dt.lkp_jurusan_id)

        this.dialogMilik.show = true;
        this.form.saveButton = "Simpan"
    },

   Singkir(dt){
         this.form_singkir = {
             id : dt.id,
             tarikh_singkir : '',
             sebab_singkir : '',
         }
         // this.files_dokumen = ''

         this.getStatusSingkir()

        this.dialogSingkir.show = true;
        this.form.saveButton = "Simpan"
    },

    PremisCarian(form){
      // this.form = {
      //     lkp_negeri_id : form.lkp_negeri_id,
      //     carian_juru : null,
      //   }

        // carian_juru : {q: ''},
        this.dialog.show = true;
        this.form.saveButton = "Simpan"
      
    },


    klickPilih(){
        for (var b in this.ternakan_list) {
          if (this.ternakan_list[b].baka == null) {
            this.ternakan_list[b].pilih = this.checkin
          }
        }
     },

      klickPi(dt){
         if(dt.pilih == false){
            dt.jenis_semen = 0;
         }
      },

    getPremis() {
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res || []

        if (this.premis.length === 1) {
          this.form.premis_id = this.premis[0].value
          this.form.lkp_negeri_id = this.premis[0].lkp_negeri_id
          this.form.lkp_negeri = this.premis[0].lkp_negeri
        }
      })
    },

    getData(){
      this.getTernakan(this.d_form, 1);
    },

    getTernakan(data, item) {
     if (item == 2) {
       this.form.lkp_ternakan_id = 0;
       if (data.premis_id != '' && data.lkp_ternakan_id != '') {
         this.$zcomm.get(
           this.api_service +
             'baka/ternakan_baka_perubahan/' +
             data.premis_id +
             '/' +
             data.lkp_ternakan_id +
             '/' +
             data.lkp_ternakan_id,
           {}
         ).then(res => {
           this.ternakan_list = res || [];
           if (Array.isArray(data.ternakan_list) && data.ternakan_list.length > 0) {
             for (var i in this.ternakan_list) {
               for (var t in data.ternakan_list) {
                 if (
                   this.ternakan_list[i].ternakan_id ==
                   data.ternakan_list[t].ternakan_id
                 ) {
                   this.ternakan_list[i].pilih = true;
                   this.ternakan_list[i].sudah_pilih = 1;
                 }
               }
             }
           }
         });
       }
     } else if (item == 3) {
       if (data.premis_id != '' && data.lkp_ternakan_id != '') {
         this.$zcomm.get(
           this.api_service +
             'baka/ternakan_baka_perubahan/' +
             data.premis_id +
             '/' +
             data.lkp_ternakan_id +
             '/' +
             data.lkp_ternakan_id,
           {}
         ).then(res => {
           this.ternakan_list = res || [];
           if (Array.isArray(data.ternakan_list) && data.ternakan_list.length > 0) {
             for (var i in this.ternakan_list) {
               for (var t in data.ternakan_list) {
                 if (
                   this.ternakan_list[i].ternakan_id ==
                   data.ternakan_list[t].ternakan_id
                 ) {
                   this.ternakan_list[i].pilih = true;
                   this.ternakan_list[i].sudah_pilih = 1;
                 }
               }
             }
           }
         });
         // contoh kalau perlu pindah tab:
         // this.activeTab = 3;
       }
     } else if (item == 1) {

       if (data.premis_id != '' && data.lkp_ternakan_id != '') {
        this.$zcomm
          .get(
            this.api_service +
              'baka/ternakan_baka_perubahan/' +
              data.premis_id +
              '/' +
              data.lkp_ternakan_id +
              '/' +
              data.lkp_ternakan_id,
            {}
          )
          .then((res) => {
            this.ternakan_list = res || [];
            if (Array.isArray(data.ternakan_list) && data.ternakan_list.length > 0) {
              for (var i in this.ternakan_list) {
                for (var t in data.ternakan_list) {
                  if (
                    this.ternakan_list[i].ternakan_id ==
                    data.ternakan_list[t].ternakan_id
                  ) {
                    this.ternakan_list[i].pilih = true;
                    this.ternakan_list[i].sudah_pilih = 1;
                  }
                }
              }
            }
          });

        
        // if (data.lkp_status_perubahan_id == 41) {
        //   this.activeTab = 3;

          
        //   this.tabs[2].disabled = true; 
        //   this.tabs[4].disabled = true; 
        //   this.tabs[3].disabled = false; 

        // } else if (data.lkp_status_perubahan_id == 7) {
        //   this.activeTab = 2;

        //   this.tabs[3].disabled = true; 
        //   this.tabs[4].disabled = true; 
        //   this.tabs[2].disabled = false; 

        // } else if (data.lkp_status_perubahan_id == 42) {
        //   this.activeTab = 4;

        //   this.tabs[2].disabled = true; 
        //   this.tabs[3].disabled = true; 
        //   this.tabs[4].disabled = false; 
        // }
      }

     } else {
       if (data.premis_id != '' && data.lkp_ternakan_id != '') {
         this.$zcomm.get(
           this.api_service +
             'baka/ternakan_baka_perubahan/' +
             data.premis_id +
             '/' +
             data.lkp_ternakan_id +
             '/' +
             data.lkp_ternakan_id,
           {}
         ).then(res => {
           this.ternakan_list = res || [];
           if (Array.isArray(data.ternakan_list) && data.ternakan_list.length > 0) {
             for (var i in this.ternakan_list) {
               for (var t in data.ternakan_list) {
                 if (
                   this.ternakan_list[i].ternakan_id ==
                   data.ternakan_list[t].ternakan_id
                 ) {
                   this.ternakan_list[i].pilih = true;
                   this.ternakan_list[i].sudah_pilih = 1;
                 }
               }
             }
           }
         });
         this.activeTab = 1;
       }
     }

     // update negeri
     for (var b in this.premis) {
       if (this.premis[b].value == data.premis_id) {
         this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
         this.form.lkp_negeri = this.premis[b].lkp_negeri;
       }
     }
   },

   setActiveTabByStatus() {
     if (this.form.lkp_status_perubahan_id == 7) {
       this.activeTab = 2;   
     } else if (this.form.lkp_status_perubahan_id == 46) {
       this.activeTab = 3;   
     } else if (this.form.lkp_status_perubahan_id == 42) {
       this.activeTab = 4;   
     } else {
       this.activeTab = 0;   
     }
   },

   onPremisSelected(value) {
  console.log("Premis ID terpilih:", value)
  const selected = this.premis.find(p => p.value === value)
  console.log("Objek terpilih:", selected)

  if (selected) {
    this.form.nama = selected.nama_premis || ''
    this.form.no_tel = selected.no_tel || ''
    this.form.alamat = selected.alamat || ''
  }
},



    send(hantar){
      this.form.hantar = hantar
      this.validateForm();
    },

    validateForm() {
        this.loading=true;
        let isValid = true;
        let jumlah_lulus = 0;

        if(this.form.hantar == 1){ 
          if(this.form.id > 0){ 
            if (this.form.lkp_status_perubahan_id != 42) {
              for (var i in this.form.ternakan_list) {
                if (this.form.ternakan_list[i].status != 1) {
                  this.$zutil.notify("Pastikan Status Sudah Di Kemaskini", false);
                  isValid = false;
                  break;
                }
              };
            }

            // Tambahkan validasi khusus untuk field PINDAH MILIK
            if (this.form.lkp_status_perubahan_id == 42) {
              if (!this.form.nama || !this.form.no_tel || !this.form.alamat) {
                this.$zutil.notify("Pastikan Nama, No. Telepon, dan Alamat sudah terisi", false);
                isValid = false;
              }
            }

            jumlah_lulus = 1;
         }
      }else if(this.form.hantar == 2){
         if(this.form.id > 0){ 
                  jumlah_lulus = 1;

         }else{
            for (var i in this.ternakan_list) {

               if(this.ternakan_list[i].pilih==true){
                  jumlah_lulus = 1;
               }

            };

         }

      }
      if(jumlah_lulus == 0 && isValid == true){
         isValid = false;
      }

       if( !this.form.lkp_ternakan_id || !this.form.lkp_status_perubahan_id){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },



    onSuccess(){
      // alert(this.form.hantar);
        if(this.form.hantar == 1){
          this.$swal({
            title: 'Anda Pasti?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                  .then(res => {
                    if (typeof this.onAfterEdit === "function") {
                      this.onAfterEdit()
                    }
                    if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('baka.perubahan.index'));
                    } else {
                      this.$zutil.notify("Berjaya disimpan", true);
                    }
                  })
              }
            }
          })
        } else {
          if (this.form.id > 0) { 
            this.form.ternakan_list = this.ternakan_list;
            this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                this.$zutil.notify("Berjaya disimpan", true);
                // let nextTab = this.setActiveTabByStatus();
                this.$inertia.visit(this.$route('baka.perubahan.permohonan', this.form.id));
              })
          } else {
            this.form.kategori_pwl = this.form.kategori_pwl
            this.form.kategori_lupus = this.form.kategori_lupus
            this.form.lkp_status_perubahan_id = this.form.lkp_status_perubahan_id
            this.form.ternakan_list = this.ternakan_list;

            this.$zcomm.post(this.resourceurl+'.store' , this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") {
                  this.onAfterAdd()
                }
                this.$zutil.notify("Berjaya disimpan", true);
                // let nextTab = this.setActiveTabByStatus();
                this.$inertia.visit(this.$route('baka.perubahan.permohonan',res.id));

              })
          }
        } 
      },

     destroyTernakan(id)
          {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            }).then((result) => {
              if (result.value) {
                this.$zcomm.delete(this.resourceurl + '.destroy',id)
                .then(res => {
                  this.sending = false;
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                    this.deletelAttahecmentImg(id)
                    this.deletelAttahecment(id)
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
              }else{ }
              })

          },

      destroyDokumen(id)
          {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            }).then((result) => {
              if (result.value) {
                this.$zcomm.delete(this.resourceurl + '.destroy_dokumen',id)
                .then(res => {
                  this.sending = false;
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                    this.deletelAttahecmentDokumen(id)
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
              }else{ }
              })

          },
    
    
    
   getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

   getJenisBaka(){
         this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
           this.jenis_baka = res
         })
       },

   getStatusSingkir(){
         this.$zcomm.get(this.api_service + 'lookup/status_singkir', {}).then(res => {
           this.status_singkir = res
         })
       },

   getKaedahPembiakan(){
         this.$zcomm.get(this.api_service + 'lookup/kaedah_pembiakan', {}).then(res => {
           this.lkp_kaedah_pembiakan = res
         })
       },
   getPerubahan(){
         this.$zcomm.get(this.api_service + 'lookup/status_perubahan', {}).then(res => {
           this.lkp_status_perubahan = res
         })
       },

   tutup(){
         this.$inertia.visit(window.route('kelahiran.index'));
       },


      validateFormMati() {
      this.loading = true;
      let isValid = true;

      // Reset error dulu
      this.errors = {};

      if (!this.form_mati.tarikh_kematian) {
        this.errors.tarikh_kematian = "Tarikh Kematian wajib diisi";
        isValid = false;
      }

      if (!this.form_mati.sebab_kematian) {
        this.errors.sebab_kematian = "Sebab Kematian wajib diisi";
        isValid = false;
      }

      if (isValid) {
        this.submitMati();
      } else {
        this.loading = false;
        this.$swal({
          icon: "error",
          title: "Validasi Gagal",
          text: "Sila lengkapi semua field wajib.",
        });
      }
    },

    validateFormSingkir() {
      this.loading = true;
      let isValid = true;

      // Reset error dulu
      this.errors = {};

      if (!this.form_singkir.tarikh_singkir) {
        this.errors.tarikh_singkir = "Tarikh Singkir wajib diisi";
        isValid = false;
      }

      if (!this.form_singkir.sebab_singkir) {
        this.errors.sebab_singkir = "Sebab Singkir wajib diisi";
        isValid = false;
      }

      if (isValid) {
        this.submitSingkir();
      } else {
        this.loading = false;
        this.$swal({
          icon: "error",
          title: "Validasi Gagal",
          text: "Sila lengkapi semua field wajib.",
        });
      }
    },


    submitMati() {
      this.$zcomm.post(this.resourceurl+'.store_baka_mati' , this.form_mati)
         .then(res => {
         
         if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
         }
         if (this.img_semasa.length > 0) {
            this.uploadImgSemasa(res.id);
         }
         if (this.img_sebelum.length > 0) {
            this.uploadImgSebelum(res.id);
         }
         if (this.files_darah.length > 0) {
            this.uploadPDFDarah(res.id);
         }
         if (this.files_postmertem.length > 0) {
            this.uploadPDFPostmertem(res.id);
         }
         if (this.files_pampasan.length > 0) {
            this.uploadPDFPampasan(res.id);
         }
         if (this.files_permit.length > 0) {
            this.uploadPDFPermit(res.id);
         }

         
         this.$zutil.notify("Berjaya disimpan", true);

         this.loadData();
         this.dialogMati.show = false;
         })
         
          .catch(err => {
            this.$zutil.notify("Ralat semasa menyimpan", false);
            console.error(err);
        });

    },

    submitSingkir() {
      this.$zcomm.post(this.resourceurl+'.store_baka_singkir' , this.form_singkir)
         .then(res => {
         
         if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
         }
           
         this.$zutil.notify("Berjaya disimpan", true);

         this.loadData();
         this.dialogSingkir.show = false;
         })
         
          .catch(err => {
            this.$zutil.notify("Ralat semasa menyimpan", false);
            console.error(err);
        });

    },

  
      uploadImgSemasa(item) 
       {  
          let formData = new FormData();
          for (var b in this.img_semasa) 
          {
              formData.append("files["+b+"]", this.img_semasa[b].file);
          }
          formData.append("model",'\\App\\Model\\BakaButiranSemasa');
          formData.append("model_id", item);
          this.$zcomm.post('attahecment.upload', formData)
              .then((res) => {
                  this.getAttahecmentImgSemasa(item);
                  this.loadData();
              })
              .catch((err) => {})
              .finally(() => {});
      },
      uploadImgSebelum(item) 
       {  
          let formData = new FormData();
          for (var b in this.img_sebelum) 
          {
              formData.append("files["+b+"]", this.img_semasa[b].file);
          }
          formData.append("model",'\\App\\Model\\BakaButiranSebelum');
          formData.append("model_id", item);
          this.$zcomm.post('attahecment.upload', formData)
              .then((res) => {
                  this.getAttahecmentImgSebelum(item);
                  this.loadData();
              })
              .catch((err) => {})
              .finally(() => {});
      },

      uploadPDFDarah(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_darah) 
       {
           formData.append("files["+b+"]", this.files_darah[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaButiranDarah');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               // this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },
      uploadPDFPostmertem(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_postmertem) 
       {
           formData.append("files["+b+"]", this.files_postmertem[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaButiranPostmertem');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               // this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   uploadPDFPampasan(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_pampasan) 
       {
           formData.append("files["+b+"]", this.files_pampasan[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaButiranPampasan');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               // this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   uploadPDFPermit(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_permit) 
       {
           formData.append("files["+b+"]", this.files_permit[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaButiranPermit');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               // this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   

       getAttahecmentImgSemasa(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSemasa'}).then(res => {
           this.attahecmentImgSemasa = res
         })
       },

       getAttahecmentImgSebelum(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSebelum'}).then(res => {
           this.attahecmentImgSebelum = res
         })
       },


       getAttahecmentDarah(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranDarah'}).then(res => {
           this.attahecmentDarah = res
         })
       },

       getAttahecmentPostmertem(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPostmertem'}).then(res => {
           this.attahecmentPostmertem = res
         })
       },

       getAttahecmentPampasan(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPampasan'}).then(res => {
           this.attahecmentPampasan = res
         })
       },

       getAttahecmentPermit(item)
       {
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranPermit'}).then(res => {
           this.attahecmentPermit = res
         })
       },

    
      deletelAttahecmentImg(id)
      {
       // if (confirm('Are you sure to delete this record?')) {
       //    this.$zcomm.get(this.$route('attahecment.delete', id), {})
       //    .then(res => {
       //     this.getAttahecmentImg();
       //      this.loadData();
       //    })
       //  }
      },



      validateFormSijil() {
         this.loading = true;
         let isValid = true;

         // Pastikan file ada
         if (!this.files || this.files.length === 0) {
            isValid = false;
            this.$zutil.notify("Sila pilih fail sijil untuk dimuat naik", false);
            this.loading = false;
            return false;
         }

         // const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

         // for (let i = 0; i < this.files.length; i++) {
         //    const file = this.files[i].file || this.files[i]; // tergantung struktur this.files

         //    // Validasi ukuran
         //    if (file.size > MAX_SIZE) {
         //       this.$zutil.notify(`"${file.name}" melebihi saiz maksimum 2MB.`, false);
         //       this.loading = false;
         //       return false;
         //    }

         //    // Validasi jenis file harus PDF
         //    if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
         //       this.$zutil.notify(`"${file.name}" bukan fail PDF.`, false);
         //       this.loading = false;
         //       return false;
         //    }
         // }

         // Lolos semua validasi
         this.submitSijil();
      },

       submitSijil() {
               // this.$swal({
               //   title: 'Anda Pasti?',
               //   // text: "Are you sure want to delete this item!",
               //   type: 'warning',
               //   showCancelButton: true,
               //   confirmButtonColor: '#3085d6',
               //   cancelButtonColor: '#d33',
               //   confirmButtonText: 'Ya',
               //   cancelButtonText: 'Tidak'
               // })
               // .then((result) => {
               //     if (result.value) {
                          
                     if (this.files.length > 0) {
                        this.uploadPDF(this.form_sijil.id);
                     }
                     this.dialogSijil.show = false;
               //     }else{ }

               // })

       },




       uploadPDF(item) 
       {  
          let formData = new FormData();
          for (var b in this.files) 
          {
              formData.append("files["+b+"]", this.files[b].file);
          }
          formData.append("model",'\\App\\Model\\BakaButiranSijil');
          formData.append("model_id", item);
          this.$zcomm.post('attahecment.upload_replace', formData)
              .then((res) => {
                  this.getAttahecment();
                  this.loadData();
              })
              .catch((err) => {})
              .finally(() => {});
      },
   


    getAttahecment(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaButiranSijil'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
         this.loadData();
       })
     }
   },


   validateFormDokumen() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         for (var i in this.baka_dokumen_list) {
            if (!this.baka_dokumen_list[i].no_kes) {
               isValid = false;
               break;
            }
         };



         if (!this.files_dokumen || this.files_dokumen.length === 0) {
               isValid = false;
               this.$zutil.notify("Sila pilih fail sijil untuk dimuat naik", false);
               this.loading = false;
               return false;
         }
         if (!this.form_dokumen.id && (!this.files_dokumen || this.files_dokumen.length === 0)) {
            if (this.form_dokumen.is_baka_dokumen === null ){
               isValid = false;
               this.$zutil.notify("Pastikan data sudah terisi", false);
               this.loading = false;
               return false;
            }
         }

         //  if (!this.form_dokumen.no_kes) {
         //       isValid = false;
         //       this.$zutil.notify("Sila isi no_kes", false);
         //       this.loading = false;
         //       return false;
         // }

         // const MAX_SIZE = 2 * 1024 * 1024; // 2 MB

         // for (let i = 0; i < this.files_dokumen.length; i++) {
         //    const file = this.files_dokumen[i].file || this.files_dokumen[i]; // tergantung struktur this.files

         //    // Validasi ukuran
         //    if (file.size > MAX_SIZE) {
         //       this.$zutil.notify(`"${file.name}" melebihi saiz maksimum 2MB.`, false);
         //       this.loading = false;
         //       return false;
         //    }

         //    // Validasi jenis file harus PDF
         //    if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
         //       this.$zutil.notify(`"${file.name}" bukan fail PDF.`, false);
         //       this.loading = false;
         //       return false;
         //    }
         // }

         if (!isValid) {
            this.$zutil.notify("Pastikan data sudah terisi", false);
            this.loading=false;
            return false;
         }
       this.submitBakaDokumen();
    },

    submitBakaDokumen() {
      this.$zcomm.post(this.resourceurl+'.store_baka_dokumen' , this.form_dokumen)
         .then(res => {
         
         if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
         }
         if (this.files_dokumen.length > 0) {
            this.uploadPDFDokumen(res.id);
         }
         this.$zutil.notify("Berjaya disimpan", true);

         this.loadData();
         this.dialogDokumen.show = false;
         })
         
          .catch(err => {
            this.$zutil.notify("Ralat semasa menyimpan", false);
            console.error(err);
        });

    },

        getPremisByNegeri(lkp_negeri_id) {
         this.premis = []
         this.form.premis_id = ''

         if (!lkp_negeri_id) return

         this.$zcomm.get(this.api_service + 'lookup/premis/' + lkp_negeri_id, {})
           .then(res => {
             this.premis = res || []

             if (this.premis.length === 1) {
               this.form.premis_id = this.premis[0].id
               this.form.nama = this.premis[0].nama_premis
               this.form.no_tel = this.premis[0].no_tel
               this.form.alamat = this.premis[0].alamat
             }
           })
       },



    

   uploadPDFDokumen(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_dokumen) 
       {
           formData.append("files["+b+"]", this.files_dokumen[b].file);
       }
       formData.append("model",'\\App\\Model\\BakaDokumen');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   


    getAttahecmentDokumen(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\BakaDokumen'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

   deletelAttahecmentDokumen(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
         this.loadData();
       })
     }
   },


   loadData() {
      if(this.form.id > 0){
        this.$zcomm.get(this.api_service + 'baka/show/'+this.form.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1
        })
      }

    },

    getLkpBakaDokumen(){
      this.$zcomm.get(this.api_service + 'lookup/lkp_baka_dokumen', {}).then(res => {
        this.lkpbakaDokumen = res
      })
    },

    updateTabs(status) {
      this.tabs = [
         { title: 'PERMOHONAN', content: '' },
         { title: 'TERNAKAN', content: '' },
      ]

         if ([7].includes(status)) this.tabs.push({ title: 'DAFTAR MATI', content: '' })
         if ([46].includes(status)) this.tabs.push({ title: 'LUPUS', content: '' })
         if ([42].includes(status)) this.tabs.push({ title: 'PINDAH MILIK', content: '' })
      },

      updateActiveTab(status) {
         // logika aktif otomatis sesuai status perubahan
         switch (status) {
            case 7:   // status MATI/LUPU
               this.activeTab = this.tabs.findIndex(t => t.title === 'DAFTAR MATI')
            break
            case 46:  // status SINGKIR
               this.activeTab = this.tabs.findIndex(t => t.title === 'LUPUS')
            break
            case 42:  // status PINDAH MILIK
               this.activeTab = this.tabs.findIndex(t => t.title === 'PINDAH MILIK')
            break

            default:  // lainnya → buka tab pertama
            this.activeTab = 0
         }
         // jika hasil findIndex -1 (tidak ditemukan), fallback ke 0
         if (this.activeTab < 0) this.activeTab = 0
      },
  
  },
  
  watch: {
  // d_form: {
  //   handler(newVal) {
  //     this.form = { ...newVal }
  //   },
  //   deep: true,
  //   immediate: true
  // },
  d_form: {
    handler(newVal) {
      if (!newVal) return
      this.updateTabs(newVal.lkp_status_perubahan_id)
      this.updateActiveTab(newVal.lkp_status_perubahan_id)
    },
    immediate: true
  }
},
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.id > 0)
    {
      this.title = 'Tambah PPERMOHONAN PENGURUSAN PERUBAHAN'
    }
    else
    {
      this.title = 'Tambah PERMOHONAN PENGURUSAN PERUBAHAN'
    }
    this.getPremis()
    this.getData()
    this.getJenisTernakan()
    this.getJenisBaka()
    this.getKaedahPembiakan()
    this.getPerubahan()
    this.getPremisByNegeri()
  }
}
</script>